<mat-dialog-actions align="end" class="p-0 d-flex" style="min-height: 0;">
    <p class="mt-1 font-title text-center font-semi-bold text-color-secondary ml-5" style="flex: 1;">Ingrese el correo
    </p>
    <mat-icon mat-dialog-close
        style="color: var(--color-primary); cursor: pointer; font-size: 32px; margin-right: 10px;">highlight_off
    </mat-icon>
</mat-dialog-actions>
<form class="row mt-5" [formGroup]="formGroup">
    <div class="col-12 mb-4">
        <div class="style-input-1 px-4">
            <mat-form-field appearance="outline">
                <input matInput formControlName="email">
            </mat-form-field>
        </div>
    </div>
    <div class="col-12 text-center mb-3">
        <div class="style-button-4">
            <button type="submit" mat-button class="mat-elevation-z3" (click)="sendEmail()">
                <div class="d-flex justify-content-center align-items-center">
                    <mat-icon class="mr-1 material-icons material-icons-outlined">send</mat-icon>
                    <span>Enviar</span>
                </div>
            </button>
        </div>
    </div>
</form>